// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SvalbardAndJanMayen from '../_raw/flag/icon_flag_svalbard_and_jan_mayen.png';

export default () => <img src={SvalbardAndJanMayen} alt="SvalbardAndJanMayen" />;
